/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponse(value) {
    if (!('RedirectUrl' in value) || value['RedirectUrl'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponseFromJSON(json) {
    return FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'RedirectUrl': json['RedirectUrl'],
    };
}
export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponseToJSON(json) {
    return FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'RedirectUrl': value['RedirectUrl'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponse.js.map